import React from 'react';
import { Route, Routes } from 'react-router-dom';

import HomePage from 'app/HomePage';
import GwReportsPage from 'app/reports';
import ResourcesPage from 'app/resources';
import AccessTestPage from 'app/accessTest';
import NxAccessPage from 'app/nx';
import Error404 from 'components/Error404';

const MainRoutes = () => {
  return (
    <Routes>
      <Route exact path={'/'} element={<HomePage />} />
      <Route path={'/gwreports'} element={<GwReportsPage />} />
      <Route path={'/gateway/resources'} element={<ResourcesPage />} />
      <Route path={'/gateway/accessTest'} element={<AccessTestPage />} />
      <Route path={'/gateway/nx'} element={<NxAccessPage />} />

      {/* 404 must be the last one */}
      <Route element={<Error404 />} />
    </Routes>
  );
};

export default MainRoutes;
